<template>
  <ion-grid class="ion-padding-top ion-padding-horizontal">
    <ion-row v-if="displayStatusesRelatedInformation" class="days-status">
      {{ fullDaysCount }} jours saisis sur {{ Object.keys(days).length }}
    </ion-row>

    <ion-row v-if="hasDays" ref="dateSelector" class="day-selector">
      <div
        v-for="day in computedDays"
        :key="'day' + day.full"
        @click="$emit('onDateClick', days[day.full])"
      >
        <div
          class="status"
          :class="{
            partial: statuses[day.raw] === 'partial',
            full: statuses[day.raw] === 'full',
          }"
        ></div>

        <div
          class="ion-activatable day"
          :class="{ selected: selectedDay === days[day.full] }"
        >
          <ion-ripple-effect></ion-ripple-effect>

          <span
            v-if="adminChanges && adminChanges[day.raw]"
            class="admin-changes-dot"
          >
            🚩
          </span>

          {{ day.text }}

          <span
            class="day-circle"
            :class="{
              'has-admin-changes': adminChanges && adminChanges[day.raw],
            }"
          >
            {{ day.number }}
          </span>

          <span
            class="report-week-total"
            v-if="dayTotals && dayTotals[day.raw]"
          >
            {{ floatToString(dayTotals[day.raw], 'h') }}
          </span>
        </div>
      </div>
    </ion-row>
  </ion-grid>
</template>

<script>
import { IonGrid, IonRow, IonRippleEffect } from '@ionic/vue';
import { floatToString } from '@/services/utils/dateUtils';

export default {
  name: 'DateSelector',

  components: {
    IonGrid,
    IonRow,
    IonRippleEffect,
  },

  props: {
    days: Object,
    dayTotals: Object,
    statuses: Object,
    adminChanges: Object,
    selectedDay: String,
  },

  emits: ['onDateClick'],

  unmounted() {
    // reset selected day when component is unmounted
    this.$emit('onDateClick', null);
  },

  methods: {
    floatToString,
  },

  computed: {
    // check if we need to display days selector (so more than one day)
    hasDays() {
      return this.days && Object.keys(this.days).length > 1;
    },

    computedDays() {
      return Object.entries(this.days).map(([day, raw]) => {
        const [text, number] = day.split(' ');

        return {
          text,
          number,
          raw,
          full: day,
        };
      });
    },

    fullDaysCount() {
      if (!this.statuses || !Object.keys(this.statuses).length) return 0;

      return Object.values(this.statuses).filter(status => status === 'full')
        .length;
    },

    displayStatusesRelatedInformation() {
      return (
        this.statuses && Object.keys(this.statuses).length > 0 && this.hasDays
      );
    },
  },
};
</script>

<style scoped lang="scss">
ion-row {
  margin-bottom: 10px;
}

.has-admin-changes {
  color: rgb(214, 133, 109);
  font-weight: bold;
}

.days-status {
  font-size: 12px;
  color: #645e4f;
}

.report-week-total {
  width: 100%;
  height: auto;
  border-radius: 0;
  font-size: 11px;
  line-height: 1.2;
}

ion-grid {
  position: sticky;
  // do not remove this version because we need it for safari
  position: -webkit-sticky;
  top: 0;
  left: 0;
  background-color: #fffcfa;
  z-index: 10;
  margin-top: 0;
}
</style>
